import 'alpinejs';
import { Model } from "vue-api-query";
import Vuetify  from "vuetify";
import Vue from "vue";
import axios from 'axios';
import VueSweetalert2 from 'vue-sweetalert2';
import vueDebounce from 'vue-debounce'
import Element from 'element-ui'
import locale from 'element-ui/lib/locale/lang/en'
import Nl2br from 'vue-nl2br'

import { TiptapVuetifyPlugin } from 'tiptap-vuetify'

// don't forget to import CSS styles
import 'tiptap-vuetify/dist/main.css';
import 'vuetify/dist/vuetify.min.css';


window.Vue = Vue;
window.$ = window.jQuery = require('jquery');
window.Swal = require('sweetalert2');
window.moment = require("moment-timezone");


Vue.use(Element, { locale })

Vue.use(VueSweetalert2);
Vue.use(vueDebounce);

// CoreUI
require('@coreui/coreui');

// Boilerplate
require('../plugins');

Model.$http = axios;
Vue.prototype.moment = window.moment;

Vue.component("paginated-table", require("../global/components/PaginatedTable.vue").default);
Vue.component('nl2br', Nl2br);

// globally mapping components
const files = require.context("./", true, /\.vue$/i);
files.keys().map(key =>
    Vue.component(
        key
            .split("/")
            .pop()
            .split(".")[0],
        files(key).default
    )
);

import { Settings } from 'luxon';
Settings.defaultLocale = 'ap';

const vuetify = new Vuetify();
Vue.use(Vuetify);

// use this package's plugin
Vue.use(TiptapVuetifyPlugin, {
  // the next line is important! You need to provide the Vuetify Object to this place.
  vuetify, // same as "vuetify: vuetify"
  // optional, default to 'md' (default vuetify icons before v2.0.0)
  iconsGroup: 'fa'
})

const app = new Vue({
    vuetify: vuetify,
    el: "#app"
});

